module.exports = __webpack_public_path__ + "static/dul-89e0cb104c76f1447e459cf0ac08cfa5.png";